
import { Component, OnInit, OnDestroy } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent {

  private chart!: am4charts.PieChart;

  ngOnInit() {
    this.createChart();
    window.addEventListener('resize', this.handleResize);
  }

  private createChart(): void {
    // Create chart instance
    this.chart = am4core.create('pieChartDiv', am4charts.PieChart);

    // Disable amCharts logo
    this.chart.logo.disabled = true;
    // Add data
    this.chart.data = [
      { category: 'Category 1', value: 40 },
      { category: 'Category 2', value: 30 },
      { category: 'Category 3', value: 20 },
      { category: 'Category 4', value: 10 }
    ];

    // Create series
    const series = this.chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = 'value';
    series.dataFields.category = 'category';
    series.slices.template.tooltipText = '{category}: {value}';
    series.labels.template.disabled = true; // Enable labels
    series.ticks.template.disabled = true; // Enable ticks

    // Configure slice appearance
    series.slices.template.fillOpacity = 0.8;

    // Add a legend   ---------------------------------- Side Description
    this.chart.legend = new am4charts.Legend();
    // this.chart.legend.position = 'right';
  }

  private handleResize = () => {
    if (this.chart) {
      this.chart.invalidate(); // Trigger an update of the chart
    }
  };

  ngOnDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  }
}